// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"1aeb9aeb","558":"b3f348a2","632":"1a9ce648","741":"adf3c07e","907":"1cbe4665"}[chunkId] + ".chunk.js";
};